export default __webpack_public_path__ + "static/media/queenUnderAttack.ff55cc14.svg";